import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/app/(main)/services/car-detailing/CarDetailingServices.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/BookingButton.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/desktop/CtaSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/desktop/HeroSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/desktop/ParallaxSection.js");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/vehicle-classifier/VehicleClassifierPopup.js");
